import { ENV_VARS, MODE } from '@env';
import { win } from '@utils/win';
export const BUILD_VERSION = ENV_VARS.VITE_BUILD_VERSION;

const devDomains = ['connect-customer.dev.hub.mastermindtms.com'] as const;

const testDomains = ['connect-customer.test.hub.mastermindtms.com'] as const;

const uatDomains = [
  'connect-customer.uat-c.hub.mastermindtms.com',
  'connect-customer.uat-e.hub.mastermindtms.com',
];

const prodDomains = ['connect-customer.hub.mastermindtms.com'] as const;

let hostname: fixMe = '';
try {
  hostname = win.location.hostname || '';
} catch {
  // noop
}

// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER = (win as anyOk).IS_CONNECT_CUSTOMER;
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_DEV_DOMAIN = devDomains.includes(hostname);
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_TEST_DOMAIN = testDomains.includes(hostname);
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_UAT_DOMAIN = uatDomains.includes(hostname);
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_PROD_DOMAIN = prodDomains.includes(hostname);
export const IS_CONNECT_CUSTOMER_NO_UAT_NO_PROD =
  IS_CONNECT_CUSTOMER &&
  !IS_CONNECT_CUSTOMER_UAT_DOMAIN &&
  !IS_CONNECT_CUSTOMER_PROD_DOMAIN;

// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_CI =
  ENV_VARS.CI === 'true' || ENV_VARS.VITE_CI === 'true';
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_LOCAL_DEV = MODE === 'development';
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_CYPRESS = Boolean(
  IS_CONNECT_CUSTOMER && (win as anyOk).Cypress,
);
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_LOCAL_CYPRESS =
  IS_CONNECT_CUSTOMER_CYPRESS && IS_CONNECT_CUSTOMER_LOCAL_DEV;
// ts-unused-exports:disable-next-line
export const IS_CONNECT_CUSTOMER_LOCAL_OR_CI_CYPRESS =
  IS_CONNECT_CUSTOMER_LOCAL_CYPRESS ||
  (IS_CONNECT_CUSTOMER_CYPRESS && IS_CONNECT_CUSTOMER_CI);
